import React from 'react';
import { Loader2, X } from 'lucide-react';

export default function BookingConfirmOverlay({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'primary',
  loading = false,
  children,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="li-booking-overlay" role="presentation" onClick={onCancel}>
      <div
        className="li-booking-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="li-booking-dialog-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button type="button" className="li-booking-dialog-close" onClick={onCancel} aria-label="Close">
          <X size={18} />
        </button>
        <p className="li-booking-dialog-eyebrow">Please confirm</p>
        <h2 id="li-booking-dialog-title" className="li-booking-dialog-title">
          {title}
        </h2>
        {message ? <p className="li-booking-dialog-message">{message}</p> : null}
        {children ? <div className="li-booking-dialog-content">{children}</div> : null}
        <div className="li-booking-dialog-actions">
          <button type="button" className="li-booking-btn li-booking-btn-secondary" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`li-booking-btn ${tone === 'danger' ? 'li-booking-btn-danger' : 'li-booking-btn-primary'}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? <Loader2 className="li-booking-btn-spinner" size={16} /> : null}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
